<template>
  <v-app>
    <!-- GENERAL MESSAGES SNACKBAR -->
    <general-message-s-b />
    <!-- CHANGE PASSWORD -->
    <v-dialog v-model="changePassDialog" width="480" persistent>
      <change-password />
    </v-dialog>
    <!-- LOADING -->
    <loading />
    <!-- MESSAGES -->
    <Messages />
    <!-- TOOLBAR -->
    <v-toolbar class="elevation-1" v-if="isLoggedIn" color="#C46D24" fixed>
      <header-all />
      <v-spacer></v-spacer>
      <v-flex class="info-user text-xs-right" mr-2>
        <v-flex d-flex align-center class="">
          <v-flex class="first-name-style text-xs-right" pr-2>
            {{ firstName }}
            <h6>{{ email }}</h6>
          </v-flex>
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="2x"
            :icon="['fal', 'user-circle']"
          />
        </v-flex>
      </v-flex>
      <v-menu bottom left nudge-bottom="40">
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-btn
            dark
            icon
            href="https://www.youtube.com/watch?v=Kz7obJo24_U"
            target="_blank"
          >
            <font-awesome-icon
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'question-circle']"
            />
          </v-btn>
        </template>

        <v-list>
          <v-list-tile
            v-for="(item, i) in menuAltItems"
            :key="i"
            @click="actionsMenu(item.action)"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#424242' }"
              size="lg"
              :icon="['fal', item.icon]"
            />
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <!-- CONTENT -->
    <v-content class="mt-5">
      <router-view />
    </v-content>
    <!-- FOOTER -->
    <v-footer v-if="isLoggedIn" dark height="auto" fixed app>
      <v-card class="flex" flat tile>
        <v-card-title v-if="role < 2" class="footer-1">
          <v-flex v-if="readOnlyCalendar" class="caption">
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'file-signature']"
            />
            Service Ticket con ID Único:
            <span>
              <b>{{ currentUID }}</b> | Estado:
              <b>{{ approvedMapIn.get(approved) }}</b>
            </span>
          </v-flex>
          <v-flex v-else class="caption">
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'file-import']"
            />
            Service Ticket en progreso!
          </v-flex>
        </v-card-title>

        <v-card-actions class="footer-2">
          <v-flex d-inline-flex align-center>
            <v-flex>
              <v-img
                :src="require('./assets/logo-blanco-experis.svg')"
                contain
                height="18"
              >
              </v-img>
            </v-flex>
            <v-flex class="footer-info"
              >CTG - {{ yearFooter }} | {{ versionApp }}</v-flex
            >
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HeaderAll from "./components/HeaderAll";
import Loading from "./components/Loading";
import Messages from "./components/Messages";
import ChangePassword from "./components/ChangePassword";
import GeneralMessageSB from "./components/GeneralMessageSB";

const approvedMap = new Map([
  [0, "En Revisión"],
  [1, "Aprobada"],
  [2, "No Aprobada"]
]);

export default {
  name: "App",
  components: {
    GeneralMessageSB,
    ChangePassword,
    HeaderAll,
    Messages,
    Loading
  },
  data() {
    return {
      approvedMapIn: approvedMap,
      menuAltItems: [
        {
          title: "Cambiar Contraseña",
          action: "changePassIn",
          icon: "exchange"
        },
        { title: "Cerrar Sesión", action: "logout", icon: "sign-out" }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "yearFooter",
      "changePassDialog",
      "firstName",
      "versionApp",
      "role",
      "approved",
      "currentUID",
      "readOnlyCalendar",
      "showMessage",
      "messageTitle",
      "messageInfo",
      "isLoggedIn",
      "email"
    ])
  },
  methods: {
    ...mapActions(["changePass", "logout", "showGeneralMessage"]),
    changePassIn() {
      this.changePass(true);
    },
    closeMessage() {
      const payload = {
        showMessage: false,
        showCancelBtn: false,
        showSendBtn: false,
        showOkBtn: false,
        action: "",
        data: "",
        messageTitle: "",
        messageInfo: ""
      };
      this.showGeneralMessage(payload);
    },
    actionsMenu(actionItem) {
      this[actionItem]();
    }
  }
};
</script>

<style lang="stylus">
h1
  color white

h2
  color #717171
  font-size 24px
  font-weight 500

h3
  color #717171
  font-size 18px
  font-weight 400

h4
  color white

h6
  color white
  font-size 10px
  font-weight 600

.info-user
  max-width 250px
  min-width 250px

.first-name-style
  font-size 9px
  color white
  max-width 230px
  min-width 230px

.footer-1
  // background-color #6E8F82
  // background-color #C46D24
  background-color #424242
  background-image url('./assets/pattern-1.svg')
  background-repeat repeat
  // color #C46D24

.footer-2
  background-color #466EA5

.footer-info
  font-size 9px
  max-width 80px
  min-width 80px
</style>
